"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CausalityDialog = void 0;
var risks_1 = require("../../interfaces/risks");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var App_1 = require("../../App");
var contexts_1 = require("../../interfaces/contexts");
var config_1 = require("../../config");
var dialog_1 = require("../dialog");
var react_tabs_1 = require("react-tabs");
var buttons_1 = require("../buttons");
var generic_1 = require("../generic");
var urls_1 = require("../../urls");
var causalitySearchExisting_1 = require("./causalitySearchExisting");
var lodash_1 = require("lodash");
var causalityUserDefinedFields_1 = require("./causalityUserDefinedFields");
var causalityCommentList_1 = require("./causalityCommentList");
var CausalityDialog = (function (_super) {
    __extends(CausalityDialog, _super);
    function CausalityDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.comments_changed = false;
        _this.debouncedSearch = (0, lodash_1.debounce)(_this.loadCausalities, config_1.DEBOUNCE_DELAY);
        _this.closeHandler = function () {
            var dialog = _this.props.isCause ? App_1.store.causeDialog : App_1.store.effectDialog;
            _this.props.onClose ? _this.props.onClose() : dialog.closeDialog();
            if (dialog.refreshAfterClose) {
                dialog.refreshAfterClose = false;
                window.location.reload();
            }
        };
        _this.state = _this.getStateFromProps(props);
        _this.loadCausalities({ searchTerm: "", statuses: risks_1.CausalityStatusChoices.INCOMPLETE });
        return _this;
    }
    CausalityDialog.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState(this.getStateFromProps(nextProps));
    };
    CausalityDialog.prototype.getStateFromProps = function (props) {
        var context = App_1.store.context.get();
        if (context instanceof contexts_1.ProjectContext) {
            var causalityPut = props.causality ? {
                id: props.causality.id,
                text: props.causality.text,
                is_cause: props.causality.is_cause,
                udf_values: props.causality.udf_values,
            } : {
                id: null,
                text: '',
                is_cause: null,
                udf_values: []
            };
            return {
                causalityPut: causalityPut,
                text: props.causality ? props.causality.text : "",
                status: props.causality ?
                    props.causality.status.toString() :
                    risks_1.CausalityStatusChoices.OPEN.toString(),
            };
        }
        else {
            throw new Error("ControlDialog does not support the current context");
        }
    };
    CausalityDialog.prototype.onUdfValueChange = function (name, value) {
        var causalityPut = this.state.causalityPut;
        causalityPut[name] = value;
        this.setState({
            causalityPut: causalityPut
        });
    };
    CausalityDialog.prototype.onTextChange = function (e) {
        this.setState({
            text: e.target.value
        });
    };
    CausalityDialog.prototype.onStatusChange = function (e) {
        this.setState({
            status: e.currentTarget.value,
        });
    };
    CausalityDialog.prototype.loadCausalities = function (options) {
        var context = App_1.store.context.get();
        if (context instanceof contexts_1.RiskContext) {
            this.props.search(options.searchTerm, this.props.isCause, options.statuses);
        }
    };
    CausalityDialog.prototype.onSearchChange = function (options) {
        this.debouncedSearch(options);
    };
    CausalityDialog.prototype.submit = function (e, close_dialog) {
        var _this = this;
        if (close_dialog === void 0) { close_dialog = false; }
        var causality = {
            id: this.props.causality ? this.props.causality.id : null,
            text: this.state.text,
            is_cause: this.props.isCause,
            status: this.state.status,
            udf_values: this.state.causalityPut.udf_values
        };
        this.props.saveCausality(causality, close_dialog).then(function () {
            _this.props.afterSaveCallback && _this.props.afterSaveCallback();
        });
    };
    CausalityDialog.prototype.submitAndClose = function (e) {
        this.submit(e, true);
    };
    CausalityDialog.prototype.submitAndCreateNew = function (e) {
        var _this = this;
        var causality = {
            id: null,
            text: this.state.text,
            is_cause: this.props.isCause,
            status: this.state.status,
            udf_values: this.state.causalityPut.udf_values
        };
        this.props.saveCausality(causality, true).then(function () {
            _this.props.afterSaveCallback && _this.props.afterSaveCallback();
            setTimeout(function () {
                _this.props.openDialog(null, _this.props.isCause);
            }, 0);
        });
    };
    CausalityDialog.prototype.attachCausality = function (causality) {
        var _this = this;
        this.props.attachCausality(causality).then(function () {
            _this.props.afterSaveCallback && _this.props.afterSaveCallback();
        });
    };
    CausalityDialog.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var texts = {
            information: props.isCause ? get_term("Cause information") : get_term("Effect information"),
            existing: props.isCause ? get_term("Existing causes") : get_term("Existing effects"),
            defaultTitle: props.isCause ? get_term("Add cause") : get_term("Add effect"),
            type: props.isCause ? get_term("Cause") : get_term("Effect"),
            save: gettext("Save")
        };
        var title = props.causality ?
            "".concat(texts.type, " #").concat(props.causality.number, ": ").concat(props.causality.text) :
            texts.defaultTitle;
        var searchResults = props.isCause ? props.causeSearchResults : props.effectSearchResults;
        var risk_relations_header = props.isCause
            ? gettext("This cause affects the following risks")
            : gettext("This effect affects the following risks");
        var state = this.state;
        return (React.createElement(dialog_1.Dialog, { isOpen: props.isOpen, forcedWidth: "950px", className: "CausalityDialog", onClose: function () {
                if (_this.comments_changed) {
                    fancyConfirm(gettext("You have unsaved changes. Are you sure you want to discard them?"), function () {
                        _this.closeHandler();
                    });
                }
                else {
                    _this.closeHandler();
                }
            }, contentLabel: title },
            React.createElement(react_tabs_1.Tabs, { selectedTabClassName: "active" },
                React.createElement(react_tabs_1.TabList, { className: "nav nav-tabs" },
                    React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                        React.createElement("a", { className: "nav-link", href: "#0" }, texts.information)),
                    props.causality ?
                        React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                            React.createElement("a", { className: "nav-link", href: "#0" }, get_term("Relations")))
                        :
                            React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                                React.createElement("a", { className: "nav-link", href: "#0" }, texts.existing))),
                React.createElement(react_tabs_1.TabPanel, null,
                    React.createElement("div", { className: "CausalityDialog__InputContainer" },
                        React.createElement("div", { className: "form-group row" },
                            React.createElement("div", { className: "col-4" },
                                React.createElement("label", { className: "col-form-label pl-3", htmlFor: "causality_status_id" }, gettext("Status"))),
                            React.createElement("div", { className: "col-8" },
                                React.createElement("select", { id: "causality_status_id", name: "status", className: "form-control", value: this.state.status, onChange: this.onStatusChange.bind(this) }, risks_1.CausalityStatusChoices.as_choices().map(function (choice) {
                                    return React.createElement("option", { key: choice.value, value: choice.value }, choice.display_name);
                                })))),
                        React.createElement("textarea", { className: "CausalityDialog__Input form-control", value: this.state.text, onChange: this.onTextChange.bind(this) }),
                        props.udfTypes.length > 0 && props.isOpen && state.causalityPut.id &&
                            React.createElement(React.Fragment, null,
                                React.createElement("h5", null, props.udfSectionHeader || gettext("User defined fields")),
                                React.createElement(causalityUserDefinedFields_1.CausalityUserDefinedFields, { udfTypes: props.udfTypes, udfValues: state.causalityPut.udf_values, target_object_id: state.causalityPut.id, onChange: this.onUdfValueChange.bind(this) }))),
                    React.createElement("div", { className: "d-flex justify-content-end align-items-end" },
                        !props.causality &&
                            React.createElement(buttons_1.OutlineButton, { onClick: this.submitAndCreateNew.bind(this) }, gettext("Save and create new")),
                        React.createElement(buttons_1.OutlineButton, { onClick: this.submitAndClose.bind(this) }, gettext("Save and close")),
                        React.createElement("div", null),
                        React.createElement(buttons_1.PrimaryButton, { onClick: this.submit.bind(this) }, gettext("Save"))),
                    props.causality &&
                        React.createElement(causalityCommentList_1.CausalityCommentSection, { comments: props.comments, onChange: function () {
                                _this.comments_changed = true;
                            }, onSubmit: function (comment) {
                                var values = {
                                    comment: comment
                                };
                                var dialog = props.isCause ? App_1.store.causeDialog : App_1.store.effectDialog;
                                dialog.postComment(values);
                                _this.comments_changed = false;
                            }, isCause: props.isCause })),
                props.causality ?
                    React.createElement(react_tabs_1.TabPanel, null,
                        React.createElement("div", { className: "Panel" },
                            React.createElement("h4", { className: "ReferenceList__Header" }, risk_relations_header),
                            React.createElement("ul", { className: "list-unstyled" },
                                React.createElement("li", null,
                                    React.createElement(App_1.LoadingSpinner, { loading: props.isLoadingRisks, size: 1 })),
                                props.affectedRisks.map(function (risk) {
                                    return React.createElement("li", { key: risk.id },
                                        React.createElement("a", { className: "RelationLink", href: risk.url },
                                            gettext("Risk"),
                                            " #",
                                            risk.number,
                                            " ",
                                            risk.title));
                                })),
                            React.createElement(generic_1.HTMXContentAnchor, null,
                                React.createElement("div", { "hx-get": (0, urls_1.resolve)(urls_1.Urls.causality_control_relations, props.causality.project, props.causality.id), "hx-trigger": "load", "hx-target": "this", "hx-swap": "innerHTML" }))))
                    :
                        React.createElement(react_tabs_1.TabPanel, null,
                            React.createElement("div", { className: "Panel" },
                                React.createElement(causalitySearchExisting_1.CausalitySearchExisting, { loading: props.isSearchingCausalities, searchResults: searchResults, onSearchChange: this.onSearchChange.bind(this), attachCausality: this.attachCausality.bind(this) }))))));
    };
    CausalityDialog = __decorate([
        mobx_react_1.observer
    ], CausalityDialog);
    return CausalityDialog;
}(React.Component));
exports.CausalityDialog = CausalityDialog;
